import { useState } from 'react';
import { useTimeTrackingSettingsAllDays } from './useTimeTrackingSettingsAllDays';

export const useTimeTrackingRestriction = () => {
  const {
    getTimeTrackingRestrictedReason,
    getProjectTrackingRestrictedReason,
    loading,
  } = useTimeTrackingSettingsAllDays();

  const [showRestrictedWarningModal, setShowRestrictedWarningModal] =
    useState<boolean>(false);

  return {
    getTimeTrackingRestrictedReason,
    getProjectTrackingRestrictedReason,
    showRestrictedWarningModal,
    setShowRestrictedWarningModal,
    timeTrackingRestrictedAbsenceLoading: loading,
  };
};
